export default "/images/framework/WordShopCht.aa8cd425.svg?aa8cd425";